import classNames from "classnames";
import { Formik, Form, Field } from "formik";
import { useState } from "react";

export const EditableField = ({
  value,
  onSubmit,
  type = "input",
  displayClassName,
  fieldClassName,
  placeholder,
  rows,
}: {
  value: string;
  onSubmit: (value: string) => void;
  type?: "textarea" | "input";
  displayClassName?: string;
  fieldClassName?: string;
  placeholder?: string;
  rows?: number;
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const isEmpty = !value || String(value).trim().length === 0;

  if (!isEditing) {
    return (
      <span
        className={classNames(displayClassName, { gray: isEmpty })}
        onClick={() => setIsEditing(true)}
        style={{ cursor: "pointer" }}
      >
        {isEmpty ? placeholder || "Click to edit" : value}
      </span>
    );
  }

  return (
    <Formik
      initialValues={{ value: value || "" }}
      onSubmit={(values) => {
        onSubmit(values.value);
        setIsEditing(false);
      }}
      enableReinitialize
    >
      <Form className="w-100 d-flex">
        <Field
          name="value"
          className={classNames("form-control", fieldClassName)}
          autoFocus
          onBlur={(e: React.FocusEvent) => {
            (e.target as HTMLFormElement).form.requestSubmit();
          }}
          as={type === "textarea" ? "textarea" : "input"}
          rows={rows}
        />
      </Form>
    </Formik>
  );
};
